



//const Serverurl= ["http://localhost:8080/xampp/athayogaliving/"]

//const Serverurl= ["http://localhost/xampp/apoorva/athayogaliving/"]

const Serverurl= ["https://backend.athayogliving.com/"]

export default Serverurl;






